// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 4/12/2024 16:53:46 by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import { AdjustmentTypeEnum } from '../../../finance/models/schema/Schema';
import { EmployeeStateTypeEnum } from '../../../appCore/models/schema/Schema';
import { JobPayTypeEnum } from '../../../appCore/models/schema/Schema';
import { ContributionTypeEnum } from '../../../finance/models/schema/Schema';
import { TaxMethodTypeEnum } from '../../../finance/models/schema/Schema';
import { TaxAgencyTypeEnum } from '../../../finance/models/schema/Schema';
import { TaxCreditAccountTypeEnum } from '../../../finance/models/schema/Schema';
import { TaxCreditTransferTypeEnum } from '../../../finance/models/schema/Schema';
import { TaxCreditTransferStatusTypeEnum } from '../../../finance/models/schema/Schema';

export enum FieldTypeEnum {
  notSpecified = 0,
  income = 1,
  benefit = 2,
  deduction = 3,
  tax = 4,
}

export enum SortByEnum {
  notSpecified = 0,
  name = 1,
  adjustmentType = 2,
  payPeriod = 3,
  adjustmentDate = 4,
}

export enum PayTypeEnum {
  notSpecified = 0,
  netPay = 1,
  grossPay = 2,
}

export enum TaxTypeEnum {
  notSpecified = 0,
  statuatory = 1,
  eHT = 2,
  wcb = 3,
}

export interface GetAdjustmentListRequestInterface {
  companyId: number;
  payGroupId?: number;
  adjustmentType: Array<AdjustmentTypeEnum>;
  skip: number;
  searchByName: string;
  take: number;
  sortBy: SortByEnum;
  isAscending: boolean;
  payPeriodId?: Array<number>;
  dateFilter?: DateFilterInterface;
}

export interface GetAdjustmentListResponseInterface {
  adjustmentListItemList: Array<AdjustmentListItemInterface>;
  validationResults: ValidationResultsInterface;
}

export interface DateFilterInterface {
  fromDate?: string;
  toDate?: string;
}

export interface PayGroupInterface {
  id: number;
  name: string;
  recentPayPeriodDate: string;
  isPayrollInPendingApproval: boolean;
  inProgressPayPeriodEndDate?: string;
  inProgressPayPeriodStartDate?: string;
  hasPayrollsInApprovedState: boolean;
  payPeriodList: Array<PayPeriodInterface>;
}

export interface AdjustmentDetailInterface {
  id: number;
  payGroup: string;
  adjustmentType: AdjustmentTypeEnum;
  adjustmentDate: string;
  useAsTaxCredits: boolean;
  memo: string;
  roeSubmitted: boolean;
  payPeriodDates: string;
  isOffCycle: boolean;
}

export interface GetEmployeeListRequestInterface {
  companyId: number;
  searchByName: string;
  adjustmentType: AdjustmentTypeEnum;
}

export interface GetEmployeeListResponseInterface {
  employeeList: Array<EmployeeInterface>;
  validationResults: ValidationResultsInterface;
}

export interface EmployeeInterface {
  id: number;
  name: string;
  status: string;
  isContractor: boolean;
  firstName: string;
  statusType: EmployeeStateTypeEnum;
  payGroupList: Array<PayGroupInterface>;
}

export interface PayPeriodInterface {
  id: number;
  payPeriodDatesString: string;
  isTransactionStatusCleared: boolean;
  roeSubmitted: boolean;
  payPeriodStartDate: string;
  payPeriodEndDate: string;
  payDate: string;
}

export interface WageInterface {
  id: number;
  description: string;
  hoursAdjustmentLedgerId?: number;
  hoursBaseFieldId?: number;
  hoursPosted: number;
  hoursAdjustment?: number;
  hoursPreviousAdjustment: number;
  amountAdjustmentLedgerId?: number;
  amountBaseFieldId?: number;
  amountAdjustment?: number;
  amountPreviousAdjustment: number;
  amountPosted: number;
  updatedHours: number;
  annualLimit?: number;
  updatedAmount: number;
  isHoursAdjusted: boolean;
  isAmountAdjusted: boolean;
}

export interface GetAdjustmentViewRequestInterface {
  id: number;
}

export interface GetAdjustmentViewResponseInterface {
  updatedNetWage: number;
  updatedGrossWage: number;
  isContractor: boolean;
  isView: boolean;
  isEdit: boolean;
  taxCreditList: Array<TaxCreditInterface>;
  adjustmentDetail: AdjustmentDetailInterface;
  jobList: Array<JobInterface>;
  stateList: Array<StateInterface>;
  validationResults: ValidationResultsInterface;
}

export interface JobInterface {
  id: number;
  name: string;
  compensation: number;
  jobPayType: JobPayTypeEnum;
  wageList: Array<WageInterface>;
  benefitList: Array<BenefitInterface>;
  deductionList: Array<DeductionInterface>;
  jobDefinition: AssociatedDataInterface;
  department: AssociatedDataInterface;
}

export interface UnderTaxInterface {
  amount: number;
  markAsPaid: boolean;
  markAsPaidDate?: string;
  description: string;
  adjustmentLedgerId: number;
  adjustmentPaymentId: number;
}

export interface PostAdjustmentRequestInterface {
  id: number;
  employeeId?: number;
  payGroupId?: number;
  payPeriodId?: number;
  adjustmentType: AdjustmentTypeEnum;
  memo: string;
  isTaxCredit: boolean;
  taxList: Array<TaxInterface>;
  provinceList: Array<ProvinceInterface>;
  taxSummaryList: Array<TaxSummaryInterface>;
}

export interface PostAdjustmentResponseInterface {
  adjustmentId: number;
  validationResults: ValidationResultsInterface;
}

export interface AdjustmentListItemInterface {
  id: number;
  payGroup: string;
  adjustmentType: string;
  payPeriodDates: string;
  adjustmentDate: string;
  employeeName: string;
  payPeriodEndDate: string;
  isOffCycle: boolean;
}

export interface UnderPayInterface {
  amount: number;
  markAsPaid: boolean;
  markAsPaidDate?: string;
  description: string;
  adjustmentLedgerId: number;
  jobId: number;
  isNonCashBenefit: boolean;
  adjustmentPaymentId: number;
}

export interface ZeroPayInterface {
  amount: number;
  markAsPaid: boolean;
  markAsPaidDate?: string;
  description: string;
  adjustmentLedgerId: number;
  jobId: number;
  isNonCashBenefit: boolean;
  adjustmentPaymentId: number;
}

export interface OverPayInterface {
  amount: number;
  markAsPaid: boolean;
  markAsPaidDate?: string;
  description: string;
  adjustmentLedgerId: number;
  jobId: number;
  isNonCashBenefit: boolean;
  adjustmentPaymentId: number;
}

export interface OverTaxInterface {
  amount: number;
  markAsCollected: boolean;
  markAsCollectedDate?: string;
  description: string;
  adjustmentLedgerId: number;
  adjustmentPaymentId: number;
  isTaxCreditApplied: boolean;
}

export interface ZeroTaxInterface {
  amount: number;
  markAsPaid: boolean;
  description: string;
  adjustmentLedgerId: number;
  adjustmentPaymentId: number;
}

export interface UpdatedAmountInterface {
  amount: number;
  description: string;
  jobId: number;
}

export interface UpdatedHoursInterface {
  hours: number;
  description: string;
  jobId: number;
}

export interface TaxCreditInterface {
  amount: number;
  description: string;
}

export interface FieldInterface {
  id: number;
  name: string;
  fieldType: string;
}

export interface PersistAdjustmentRequestInterface {
  id: number;
  employeeId?: number;
  payGroupId?: number;
  payPeriodId?: number;
  adjustmentType: AdjustmentTypeEnum;
  jobList: Array<JobInterface>;
  taxList: Array<TaxInterface>;
}

export interface PersistAdjustmentResponseInterface {
  adjustmentId: number;
  validationResults: ValidationResultsInterface;
}

export interface BenefitInterface {
  id: number;
  description: string;
  posted: number;
  adjustment?: number;
  previousAdjustment: number;
  updated: number;
  annualLimit?: number;
  baseFieldId: number;
  amountLedgerId?: number;
  isAmountAdjusted: boolean;
  isNonCashBenefit: boolean;
  isAnnualLimitSetted: boolean;
}

export interface DeductionInterface {
  id: number;
  description: string;
  posted: number;
  adjustment?: number;
  previousAdjustment: number;
  updated: number;
  annualLimit?: number;
  baseFieldId: number;
  amountLedgerId?: number;
  isAmountAdjusted: boolean;
  isAnnualLimitSetted: boolean;
}

export interface TaxInterface {
  id: number;
  description: string;
  adjustment?: number;
  updated: number;
  baseFieldId: number;
  amountLedgerId?: number;
  posted: number;
  annualLimit?: number;
  canEdit: boolean;
  reducedRate?: number;
  rate?: number;
  isReducedRate?: boolean;
  calculateBaseFieldId: number;
  taxType: TaxTypeEnum;
  contributionType: ContributionTypeEnum;
  taxMethodType: TaxMethodTypeEnum;
  taxAgencyType: TaxAgencyTypeEnum;
  yTDAmount: number;
  shortCode: string;
  code: string;
}

export interface GetAdjustmentDetailRequestInterface {
  employeeId?: number;
  payPeriodId?: number;
  companyId: number;
  payGroupId: number;
  adjustmentType: AdjustmentTypeEnum;
}

export interface GetAdjustmentDetailResponseInterface {
  provinceList: Array<ProvinceInterface>;
  adjustmentDetail: AdjustmentDetailInterface;
  validationResults: ValidationResultsInterface;
}

export interface MarkedCompleteRequestInterface {
  markedPaymentList: Array<MarkedPaymentInterface>;
}

export interface MarkedCompleteResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface MarkedPaymentInterface {
  adjustmentLedgerId: number;
  marked: boolean;
  adjustmentPaymentId: number;
}

export interface GetCreditListRequestInterface {
  companyId: number;
  year: number;
}

export interface GetCreditListResponseInterface {
  taxCreditSummaryList: Array<TaxCreditSummaryInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetCreditDetailRequestInterface {
  taxAccountId: number;
  taxCreditAccountType: TaxCreditAccountTypeEnum;
  year?: number;
}

export interface GetCreditDetailResponseInterface {
  newAccountNumber: string;
  newAccountAddedDate?: string;
  taxCreditDetailList: Array<TaxCreditDetailInterface>;
  validationResults: ValidationResultsInterface;
}

export interface TaxCreditSummaryInterface {
  taxCreditIdList: Array<number>;
  taxAgencyName: string;
  accountNumber: string;
  availableCredit: number;
  appliedCredit: number;
  remainingCredit: number;
  accountUpdatedDate?: string;
  newAccountNumber: string;
  newAccountAddedDate: string;
  taxCreditTransferType: TaxCreditTransferTypeEnum;
  agencyId: number;
  isActive: boolean;
  taxAccountId: number;
  taxCreditAccountType: TaxCreditAccountTypeEnum;
  taxCreditTransferStatusType: TaxCreditTransferStatusTypeEnum;
  transferredCredit: number;
}

export interface TaxCreditDetailInterface {
  accountNumber: string;
  appliedCredit: number;
  invoiceNumber: string;
}

export interface GetTaxFieldListRequestInterface {
  companyId: number;
  searchByName: string;
  employeeId?: number;
  stateId: number;
  payPeriodId?: number;
  adjustmentType: AdjustmentTypeEnum;
}

export interface GetTaxFieldListResponseInterface {
  taxFieldList: Array<TaxFieldInterface>;
  validationResults: ValidationResultsInterface;
}

export interface TaxFieldInterface {
  id: number;
  description: string;
  baseFieldId: number;
  code: string;
  reducedRate?: number;
  rate?: number;
  isReducedRate?: boolean;
  canEdit: boolean;
  calculateBaseFieldId: number;
  taxAgencyType: TaxAgencyTypeEnum;
  taxType: TaxTypeEnum;
  contributionType: ContributionTypeEnum;
  shortCode: string;
  annualLimit?: number;
}

export interface GetSummaryRequestInterface {
  employeeId?: number;
  payGroupId?: number;
  payPeriodId?: number;
  adjustmentType: AdjustmentTypeEnum;
  companyId: number;
  taxList: Array<TaxInterface>;
  provinceList: Array<ProvinceInterface>;
}

export interface GetSummaryResponseInterface {
  isRemitTax: boolean;
  adjustmentList: Array<AdjustmentInterface>;
  taxSummaryList: Array<TaxSummaryInterface>;
  validationResults: ValidationResultsInterface;
}

export interface AdjustmentInterface {
  payType: PayTypeEnum;
  postedAmount: number;
  updatedAmount: number;
  jobId: number;
  stateId: number;
  adjustmentAmount: number;
}

export interface ProvinceInterface {
  id: number;
  name: string;
  code: string;
  isPrimary: boolean;
  jobList: Array<JobInterface>;
  taxList: Array<TaxInterface>;
  pay: PayInterface;
}

export interface StateInterface {
  id: number;
  name: string;
  code: string;
  isPrimary: boolean;
  overPayList: Array<OverPayInterface>;
  underPayList: Array<UnderPayInterface>;
  overTaxList: Array<OverTaxInterface>;
  underTaxList: Array<UnderTaxInterface>;
  updatedAmountList: Array<UpdatedAmountInterface>;
  updatedHoursList: Array<UpdatedHoursInterface>;
  payList: Array<AdjustmentIncomeInterface>;
  zeroTaxList: Array<ZeroTaxInterface>;
  zeroPayList: Array<ZeroPayInterface>;
}

export interface PayInterface {
  id: string;
  updated: number;
  posted: number;
  adjustment?: number;
  payType: PayTypeEnum;
}

export interface GetEmployerTaxDetailRequestInterface {
  companyId: number;
  employeeId?: number;
  adjustmentType: AdjustmentTypeEnum;
  payPeriodId?: number;
  provinceList: Array<ProvinceInterface>;
}

export interface GetEmployerTaxDetailResponseInterface {
  provinceList: Array<ProvinceInterface>;
  validationResults: ValidationResultsInterface;
}

export interface EmployerTaxInterface {
  id: number;
  description: string;
  adjustment: number;
  updated: number;
  baseFieldId: number;
  amountLedgerId?: number;
  posted: number;
  annualLimit?: number;
  taxType: TaxTypeEnum;
  taxAgencyType: TaxAgencyTypeEnum;
  stateId: number;
  yTDAmount: number;
  canEdit: boolean;
  taxMethodType: TaxMethodTypeEnum;
  calculateBaseFieldId: number;
  isReducedRate?: boolean;
  reducedRate?: number;
  rate?: number;
}

export interface TaxSummaryInterface {
  taxType: TaxTypeEnum;
  postedAmount: number;
  updatedAmount: number;
  stateId: number;
  taxAgencyType: TaxAgencyTypeEnum;
  description: string;
  taxMethodType: TaxMethodTypeEnum;
  taxAgencyId: number;
  adjustmentAmount: number;
  taxAmountDetailList: Array<TaxAmountDetailInterface>;
}

export interface GetInitialStateRequestInterface {
  companyId: number;
  includeTaxCreditList: boolean;
}

export interface GetInitialStateResponseInterface {
  taxCreditYearList: Array<number>;
  canCreateAdjustment: boolean;
  isViewAdjustment: boolean;
  canEditAdjustment: boolean;
  validationResults: ValidationResultsInterface;
}

export interface CalculateStatuatoryEmployerTaxRequestInterface {
  employeeId: number;
  adjustedAmount: number;
  baseFieldId: number;
  taxYear: number;
  stateId: number;
  companyId: number;
  adjustmentType: AdjustmentTypeEnum;
  payPeriodId?: number;
  calculatePriorPayroll: boolean;
}

export interface CalculateStatuatoryEmployerTaxResponseInterface {
  statuatoryEmployerTaxAmount?: number;
  calculatedBaseFieldId: number;
  validationResults: ValidationResultsInterface;
}

export interface GetWorkersCompensationDetailRequestInterface {
  companyId: number;
  employeeId?: number;
  adjustmentType: AdjustmentTypeEnum;
  payPeriodId?: number;
  provinceList: Array<ProvinceInterface>;
}

export interface GetWorkersCompensationDetailResponseInterface {
  provinceList: Array<ProvinceInterface>;
  validationResults: ValidationResultsInterface;
  isEmployeeWcbEnabled?: boolean;
}

export interface CalculateEmployerHealthTaxRequestInterface {
  employeeId: number;
  adjustedAmount: number;
  baseFieldIdList: Array<number>;
  taxYear: number;
  stateId: number;
  companyId: number;
  payPeriodId?: number;
  adjustmentType: AdjustmentTypeEnum;
  province: ProvinceInterface;
}

export interface CalculateEmployerHealthTaxResponseInterface {
  taxList: Array<TaxInterface>;
  validationResults: ValidationResultsInterface;
}

export interface TaxAmountDetailInterface {
  baseFieldId: number;
  postedAmount: number;
  updatedAmount: number;
  description: string;
  adjustmentAmount: number;
}

export interface PersistTransferInstructionRequestInterface {
  taxCreditTransferType: TaxCreditTransferTypeEnum;
  taxAccountId: number;
  taxCreditAccountType: TaxCreditAccountTypeEnum;
}

export interface PersistTransferInstructionResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface AssociatedDataInterface {
  id: number;
  name: string;
}

export interface GetAdjustmentHistoryRequestInterface {
  id: number;
}

export interface GetAdjustmentHistoryResponseInterface {
  employeeName: string;
  isContractor: boolean;
  isView: boolean;
  isEdit: boolean;
  updatedGrossWage: number;
  updatedNetWage: number;
  originalNetWage: number;
  originalTax: number;
  updatedTax: number;
  adjustmentNetWage: number;
  adjustmentTax: number;
  adjustmentHistoryStateList: Array<AdjustmentHistoryStateInterface>;
  adjustmentHistoryDetail: AdjustmentHistoryDetailInterface;
  validationResults: ValidationResultsInterface;
}

export interface AdjustmentIncomeInterface {
  amount: number;
  markAsPaid: boolean;
  markAsPaidDate?: string;
  description: string;
  adjustmentLedgerId: number;
  jobId: number;
  isNonCashBenefit: boolean;
  adjustmentPaymentId: number;
  fieldType: FieldTypeEnum;
  postedAmount: string;
  postedHours: string;
  hours: string;
  updatedAmount: number;
  state: StateInterface;
}

export interface AdjustmentHistoryStateInterface {
  id: number;
  name: string;
  code: string;
  isPrimary: boolean;
  adjustmentHistoryList: Array<AdjustmentHistoryInterface>;
}

export interface AdjustmentHistoryInterface {
  id: number;
  date: string;
  madeBy: string;
  taxList: Array<TaxInterface>;
  jobList: Array<JobInterface>;
}

export interface AdjustmentHistoryDetailInterface {
  id: number;
  payGroup: string;
  adjustmentType: AdjustmentTypeEnum;
  adjustmentDate: string;
  useAsTaxCredits: boolean;
  memo: string;
  roeSubmitted: boolean;
  payPeriodDates: string;
  payDate?: string;
  recentPayPeriodDate?: string;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

import { Post } from '../../../httpClient';

export class AdjustmentAccessService {
  getAdjustmentList(request: GetAdjustmentListRequestInterface): Promise<GetAdjustmentListResponseInterface> {
    return Post('/PayrollAdjustmentAccess/getAdjustmentList', request);
  }

  getEmployeeList(request: GetEmployeeListRequestInterface): Promise<GetEmployeeListResponseInterface> {
    return Post('/PayrollAdjustmentAccess/getEmployeeList', request);
  }

  getAdjustmentView(request: GetAdjustmentViewRequestInterface): Promise<GetAdjustmentViewResponseInterface> {
    return Post('/PayrollAdjustmentAccess/getAdjustmentView', request);
  }

  postAdjustment(request: PostAdjustmentRequestInterface): Promise<PostAdjustmentResponseInterface> {
    return Post('/PayrollAdjustmentAccess/postAdjustment', request);
  }

  persistAdjustment(request: PersistAdjustmentRequestInterface): Promise<PersistAdjustmentResponseInterface> {
    return Post('/PayrollAdjustmentAccess/persistAdjustment', request);
  }

  getAdjustmentDetail(request: GetAdjustmentDetailRequestInterface): Promise<GetAdjustmentDetailResponseInterface> {
    return Post('/PayrollAdjustmentAccess/getAdjustmentDetail', request);
  }

  markedComplete(request: MarkedCompleteRequestInterface): Promise<MarkedCompleteResponseInterface> {
    return Post('/PayrollAdjustmentAccess/markedComplete', request);
  }

  getCreditList(request: GetCreditListRequestInterface): Promise<GetCreditListResponseInterface> {
    return Post('/PayrollAdjustmentAccess/getCreditList', request);
  }

  getCreditDetail(request: GetCreditDetailRequestInterface): Promise<GetCreditDetailResponseInterface> {
    return Post('/PayrollAdjustmentAccess/getCreditDetail', request);
  }

  getTaxFieldList(request: GetTaxFieldListRequestInterface): Promise<GetTaxFieldListResponseInterface> {
    return Post('/PayrollAdjustmentAccess/getTaxFieldList', request);
  }

  getSummary(request: GetSummaryRequestInterface): Promise<GetSummaryResponseInterface> {
    return Post('/PayrollAdjustmentAccess/getSummary', request);
  }

  getEmployerTaxDetail(request: GetEmployerTaxDetailRequestInterface): Promise<GetEmployerTaxDetailResponseInterface> {
    return Post('/PayrollAdjustmentAccess/getEmployerTaxDetail', request);
  }

  getInitialState(request: GetInitialStateRequestInterface): Promise<GetInitialStateResponseInterface> {
    return Post('/PayrollAdjustmentAccess/getInitialState', request);
  }

  calculateStatuatoryEmployerTax(
    request: CalculateStatuatoryEmployerTaxRequestInterface
  ): Promise<CalculateStatuatoryEmployerTaxResponseInterface> {
    return Post('/PayrollAdjustmentAccess/calculateStatuatoryEmployerTax', request);
  }

  getWorkersCompensationDetail(
    request: GetWorkersCompensationDetailRequestInterface
  ): Promise<GetWorkersCompensationDetailResponseInterface> {
    return Post('/PayrollAdjustmentAccess/getWorkersCompensationDetail', request);
  }

  calculateEmployerHealthTax(
    request: CalculateEmployerHealthTaxRequestInterface
  ): Promise<CalculateEmployerHealthTaxResponseInterface> {
    return Post('/PayrollAdjustmentAccess/calculateEmployerHealthTax', request);
  }

  persistTransferInstruction(
    request: PersistTransferInstructionRequestInterface
  ): Promise<PersistTransferInstructionResponseInterface> {
    return Post('/PayrollAdjustmentAccess/persistTransferInstruction', request);
  }

  getAdjustmentHistory(request: GetAdjustmentHistoryRequestInterface): Promise<GetAdjustmentHistoryResponseInterface> {
    return Post('/PayrollAdjustmentAccess/getAdjustmentHistory', request);
  }
}

export default new AdjustmentAccessService();
